export enum ECurrency {
  EUR = 'EUR',
}
